module.exports = __webpack_public_path__ + "img/promission2.bb6072fd.jpeg";